import { auth } from './../base';
import request from './../utils/request';
import ApiRequestError from '../components/ApiRequestError';

const serialize = function(obj, prefix) {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + '[' + p + ']' : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? serialize(v, k)
          : encodeURIComponent(k) + '=' + encodeURIComponent(v)
      );
    }
  }
  return str.join('&');
};

const parseQuery = v => {
  if (!v) return '';
  if (typeof v === 'object') return '?' + serialize(v);
  return '?' + v.replace(/^\?+/, '');
};

const exec = (endpoint, { querystring, ...config }) => {
  // config:{mode: "no-cors"}
  return request(
    process.env.REACT_APP_BASE_URL_API.replace(
      /\$(\w+)/g,
      (_$0, $1) => window.location[$1]
    ) +
      endpoint +
      '.php' +
      parseQuery(querystring),
    config
  )
  .then(response => {
    if (204 === response.status) {
      return { json: {}, response };
    }

    return response
      .text()
      .then(text => (text.length?{ json: JSON.parse(text), response }:{ response }))
      .catch(error => {
        console.log(error);
        return Promise.reject(new ApiRequestError(0, [{ type : "PARSING_ERROR" }], { response, error }))
      });
  })
  .then(result => {
    if (!result.response.ok) {
      return Promise.reject(new ApiRequestError(result.response.status, result.json.error_messages, result));
    }

    return result;
  }, error => {
    console.error("Error", error);

    return Promise.reject(error instanceof ApiRequestError?error:new ApiRequestError(0, [], {}));
  });
};

const mount = (value) => {
  const data = new FormData();

  (function recursive (key, value) {
    if (value instanceof FileList) {
      for (let ai = 0, at = value.length;ai < at;++ai) {
        data.append(key + "[]", value[ai]);
      }
    } else if (value instanceof File) {
      data.append(key, value);
    } else if (value instanceof Array) {
      for (let ai = 0, at = value.length;ai < at;++ai) {
        recursive(key + "[" + ai + "]", value[ai]);
      }
    } else if (value instanceof Object) {
      if (key) {
        Object.keys(value).forEach(ai => {
          recursive(key + "[" + ai + "]", value[ai]);
        });
      } else {
        Object.keys(value).forEach(key => {
          recursive(key, value[key]);
        });
      }
    } else {
      data.append(key, value);
    }
  })(null, value);

  return data;
};

export default (endpoint, authenticated, config = {}) => {
  if (config.headers && 'multipart/form-data' === config.headers['Content-Type']) {
    const body = mount(config.body);
    delete config.headers['Content-Type'];
    config = {
      ...config,
      body
    };
  } else {
    config = {
      ...config,
      headers: {
        'Content-Type': 'application/json',
        ...config.headers
      },
      body: JSON.stringify(config.body)
    };
  }

  if (!auth.currentUser) {
    if (authenticated) {
      return Promise.reject(
        new Error('You must be logged in to proceed with this request.')
      );
    }

    return exec(endpoint, config);
  }

  return auth.currentUser
    .getIdToken(false)
    .then(token => {
      config.headers['Authorization'] = 'Bearer ' + token;
      return exec(endpoint, config);
    }, error => {
      if (authenticated) {
        console.log(error);
        return Promise.reject(
          new Error('You must be logged in to proceed with this request.')
        );
      }

      return exec(endpoint, config);
    });
};



// WEBPACK FOOTER //
// ./src/middlewares/callApi_mysql.js